var _circle, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "url(#paint0_linear_2162_22488)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7365 13.5154C19.7889 13.3265 19.5565 13.1951 19.4038 13.3182C18.2184 14.2744 16.6827 14.8023 15.0436 14.6873C11.6002 14.4457 9.00472 11.4585 9.24628 8.01521C9.33516 6.7484 9.79566 5.59634 10.5138 4.6581C10.6331 4.50221 10.4957 4.27296 10.308 4.33063C7.43036 5.21501 5.25195 7.79429 5.02865 10.9773C4.73877 15.1092 7.8534 18.6939 11.9854 18.9837C15.604 19.2376 18.8028 16.8804 19.7365 13.5154Z",
    fill: "url(#paint1_linear_2162_22488)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8538 7.11306C14.5803 7.02189 14.5803 6.63502 14.8538 6.54385L15.979 6.16878C16.0686 6.13892 16.1389 6.06863 16.1688 5.97905L16.5438 4.85384C16.635 4.58033 17.0219 4.58033 17.113 4.85384L17.4881 5.97905C17.518 6.06863 17.5883 6.13892 17.6778 6.16878L18.803 6.54385C19.0765 6.63502 19.0765 7.02189 18.803 7.11306L17.6778 7.48813C17.5883 7.51799 17.518 7.58828 17.4881 7.67786L17.113 8.80307C17.0219 9.07658 16.635 9.07658 16.5438 8.80307L16.1688 7.67786C16.1389 7.58828 16.0686 7.51799 15.979 7.48813L14.8538 7.11306Z",
    fill: "url(#paint2_linear_2162_22488)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8538 10.5438C11.5803 10.635 11.5803 11.0219 11.8538 11.1131L12.979 11.4881C13.0686 11.518 13.1389 11.5883 13.1688 11.6779L13.5438 12.8031C13.635 13.0766 14.0219 13.0766 14.113 12.8031L14.4881 11.6779C14.518 11.5883 14.5883 11.518 14.6778 11.4881L15.803 11.1131C16.0765 11.0219 16.0765 10.635 15.803 10.5438L14.6778 10.1688C14.5883 10.1389 14.518 10.0686 14.4881 9.97905L14.113 8.85384C14.0219 8.58033 13.635 8.58033 13.5438 8.85384L13.1688 9.97905C13.1389 10.0686 13.0686 10.1389 12.979 10.1688L11.8538 10.5438Z",
    fill: "url(#paint3_linear_2162_22488)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2162_22488",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4DFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2162_22488",
    x1: 12.377,
    y1: 4.32153,
    x2: 12.377,
    y2: 19.0024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F5FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39C6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2162_22488",
    x1: 12.377,
    y1: 4.32153,
    x2: 12.377,
    y2: 19.0024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F5FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39C6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2162_22488",
    x1: 12.377,
    y1: 4.32153,
    x2: 12.377,
    y2: 19.0024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F5FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39C6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNight);
export default __webpack_public_path__ + "static/media/Night.e805d7848de86a38cb56fea3a51e65c0.svg";
export { ForwardRef as ReactComponent };